import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

export const ProDirectoryRevisionsDialogSkeleton = () => (
  <Box sx={{ display: 'flex', flex: 1 }}>
    <Box sx={{ width: 220, flexShrink: 0, borderRight: '1px solid', borderColor: 'divider', p: 2 }}>
      <Skeleton width={80} height={16} sx={{ mb: 1.5 }} />
      {[1, 2, 3].map(i => (
        <Skeleton key={i} variant="rounded" height={64} sx={{ mb: 1 }} />
      ))}
    </Box>
    <Divider orientation="vertical" flexItem />
    <Box sx={{ flex: 1, px: 3, pt: 2 }}>
      <Skeleton variant="rounded" height={48} sx={{ mb: 2 }} />
      <Box sx={{ display: 'flex', gap: 2, mb: 2.5 }}>
        <Skeleton variant="rounded" width={120} height={120} />
        <Skeleton variant="rounded" width={120} height={120} />
      </Box>
      {[1, 2, 3, 4, 5].map(i => (
        <Box key={i} sx={{ mb: 2 }}>
          <Skeleton width={100} height={14} sx={{ mb: 0.5 }} />
          <Skeleton width="60%" height={20} />
        </Box>
      ))}
    </Box>
  </Box>
);
